import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import JSBI from "jsbi";
import { SolidityType } from "../constants";
import { NETWORK_CONFIG } from "../../../../src/config";
import { validateSolidityTypeInstance } from "../utils";
/**
 * A currency is any fungible financial instrument on Ethereum, including Ether and all ERC20 tokens.
 *
 * The only instance of the base class `Currency` is Ether.
 */ export var Currency = /*#__PURE__*/ function() {
    "use strict";
    function Currency(decimals, symbol, name) {
        _class_call_check(this, Currency);
        validateSolidityTypeInstance(JSBI.BigInt(decimals), SolidityType.uint8);
        this.decimals = decimals;
        this.symbol = symbol;
        this.name = name;
    }
    var _proto = Currency.prototype;
    _proto.resetCurrency = function resetCurrency(chainId) {
        var ref, ref1, ref2;
        this.symbol = (ref = NETWORK_CONFIG[chainId]) === null || ref === void 0 ? void 0 : ref.symbol;
        this.decimals = (ref1 = NETWORK_CONFIG[chainId]) === null || ref1 === void 0 ? void 0 : ref1.decimals;
        this.name = (ref2 = NETWORK_CONFIG[chainId]) === null || ref2 === void 0 ? void 0 : ref2.tokenName;
    };
    Currency.getInstance = function getInstance() {
        if (!Currency.instance) {
            Currency.instance = new Currency(18, "BNB", "BNB");
        }
        return Currency.instance;
    };
    return Currency;
}();
var ETHER = Currency.getInstance();
export { ETHER };
